import React from "react";
import ProductCard from "./ProductCard";
//product data
import { useQuery } from "react-query";
import ProductRequests from "../../api/product.requests";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductPlaceHolder from "./ProductPlaceHolder";

const ProductCorousel = () => {
  const { isLoading, data } = useQuery("products", ProductRequests.getMany);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  return (
    <div style={{ marginTop: "24px" }}>
      {data && (
        <Slider {...settings}>
          {isLoading &&
            [1, 2, 3, 4].map((item) => (
              <ProductPlaceHolder key={`placeholder-${item}`} />
            ))}
          {data &&
            data.products.map((product) => (
              <ProductCard key={`product-${product.id}`} {...product} />
            ))}
        </Slider>
      )}
    </div>
  );
};

export default ProductCorousel;
